var map = {
	"./Aakarsh Singh.jpeg": 3796,
	"./Apoorva.jpeg": 3060,
	"./HarshitPC.jpeg": 4386,
	"./KartikeyPC.jpeg": 5220,
	"./Lakshya Goel.jpeg": 284
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7711;
module.exports = webpackAsyncContext;